// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bsk4","label":"styles_label__2alor"};